import { IResumeItem } from '@medely/types';
import useGraphQLRequest from './useGraphQLRequest';
import { GET_WORK_HISTORIES } from '../graphql/resumeQueries';
import { useQuery } from '@tanstack/react-query';

interface IUseWorkHistoriesReturn {
  workHistories: IResumeItem[];
  isLoading: boolean;
}

const useWorkHistories = (): IUseWorkHistoriesReturn => {
  const { request } = useGraphQLRequest();

  const fetchWorkHistories = async () => {
    const { workHistories } = await request(GET_WORK_HISTORIES, {
      input: { orderBy: { start_date: false } },
    });
    return workHistories;
  };

  const { data, isLoading } = useQuery(['workHistories'], fetchWorkHistories, {});

  return {
    workHistories: data ?? [],
    isLoading,
  };
};

export default useWorkHistories;
